export const userConstants = {
    LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',

    USER_LIST_REQUEST: 'USER_LIST_REQUEST',
    USER_LIST_SUCCESS: 'USER_LIST_REQUEST',
    USER_LIST_FAILURE: 'USER_LIST_REQUEST',

    USER_GET_BY_ID_SUCCESS: "USER_GET_BY_ID_SUCCESS",
    USER_GET_BY_ID_FAILURE: "USER_GET_BY_ID_FAILURE",
    USER_GET_BY_ID_CLEAR: "USER_GET_BY_ID_CLEAR",
};
